import './App.css'
import MyHed from "../src/Components/Header/Header";
import Mynav from "../src/Components/Navbar/Navbar";
import Footer from "../src/Components/Footer/Footer";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./Routes";


function App() {
  return (
    <>
  
      <MyHed />
      <Mynav routes={routes} />
      <Routes>
        {routes.map(
          ({ path, element, submenu }, key) =>
            element ? (<Route key={key} exact path={path} element={element} />) :
              (
                submenu && submenu.map(
                  ({ path, element }, key) =>
                    element && <Route key={key} exact path={path} element={element} />
                )
              )
        )}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
      <Footer routes={routes} />
    </>
  );
}

export default App;
